/**
 * VAVCI · Pestañas de la sección Productos (destacados por categoría).
 *
 * Mejora progresiva: los paneles se renderizan visibles y apilados (con encabezado
 * por categoría) para SEO/no-JS. Este módulo marca el contenedor `[data-vprod-tabs]`
 * como `is-enhanced` (el CSS oculta encabezados + paneles inactivos y muestra la
 * barra de pestañas) y gestiona el cambio de pestaña, ARIA, navegación por teclado
 * y el destino del enlace "Ver todos".
 *
 * Multi-instancia e idempotente: cada contenedor se inicializa una sola vez.
 * Patrón ARIA de pestañas con activación automática (contenido precargado).
 */
function initTabs(wrap) {
  if (wrap.dataset.vprodTabsInit === '1') return;

  const tablist = wrap.querySelector('[role="tablist"]');
  if (!tablist) return;
  const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
  if (!tabs.length) return;

  wrap.dataset.vprodTabsInit = '1';

  const panels = tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
  const section = wrap.closest('.shopify-section') || document;
  const seeAll = section.querySelector('[data-vprod-tablink]');

  function activate(index, setFocus) {
    tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      tab.classList.toggle('is-active', selected);
      const panel = panels[i];
      if (panel) panel.classList.toggle('is-active', selected);
    });
    if (setFocus) tabs[index].focus();
    if (seeAll) {
      const url = tabs[index].getAttribute('data-collection-url');
      if (url) {
        seeAll.setAttribute('href', url);
        seeAll.removeAttribute('aria-disabled');
      } else {
        // Colección sin definir (p. ej. desconectada en el editor): deshabilita.
        seeAll.setAttribute('href', '#');
        seeAll.setAttribute('aria-disabled', 'true');
      }
    }
  }

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => activate(i, false));
    tab.addEventListener('keydown', (event) => {
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      if (next !== null) {
        event.preventDefault();
        activate(next, true);
      }
    });
  });

  wrap.classList.add('is-enhanced');

  // Estado activo coherente (por si el HTML no marcó ninguno como seleccionado).
  const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
  activate(current >= 0 ? current : 0, false);
}

function boot() {
  document.querySelectorAll('[data-vprod-tabs]').forEach(initTabs);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

// Editor de temas: re-inicializa al recargar/añadir la sección.
document.addEventListener('shopify:section:load', boot);
